import { render, staticRenderFns } from "./DetailsCycles.vue?vue&type=template&id=79ae6a40&scoped=true&"
import script from "./DetailsCycles.vue?vue&type=script&lang=js&"
export * from "./DetailsCycles.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCycles.vue?vue&type=style&index=0&id=79ae6a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ae6a40",
  null
  
)

export default component.exports